import { agentNameStorageKey, timestampStorageKey } from '../../../constants/liveChat.js';
import { addDaysToTimestampInMs } from '../../../utils/dateUtils.js';
import { isLocalStorageAvailable } from '../../../utils/isLocalStorageAvailable.js';
export class LiveChatHistoryService {
    static getAll() {
        const history = this.retrieveFromLocalStorage();
        if (history) {
            this.deleteExpired(history);
            return history;
        }
        return;
    }
    static deleteOne(timestamp) {
        const history = this.retrieveFromLocalStorage();
        if (history) {
            delete history[timestamp];
            this.saveToLocalStorage(history);
        }
    }
    static upsertOne(timestamp, historyItem) {
        const history = this.retrieveFromLocalStorage();
        if (!history) {
            this.saveToLocalStorage({ [timestamp]: historyItem });
        }
        else {
            history[timestamp] = historyItem;
            this.saveToLocalStorage(history);
        }
        return timestamp;
    }
    static migrateActiveChatToHistory(activeChat) {
        if (!this.shouldUseLocalStorage) {
            return;
        }
        const localStorageTimestamp = localStorage.getItem(timestampStorageKey);
        const localStorageAgentName = localStorage.getItem(agentNameStorageKey);
        if (!localStorageTimestamp || !localStorageAgentName) {
            return;
        }
        const mappedMessages = activeChat.map((message) => {
            var _a;
            return ({
                Content: (_a = message.text) !== null && _a !== void 0 ? _a : '',
                ParticipantRole: message.isUser ? 'CUSTOMER' : 'AGENT',
                time: message.timestamp,
            });
        });
        this.upsertOne(Number(localStorageTimestamp), {
            agentName: localStorageAgentName,
            expiry: addDaysToTimestampInMs(Number(localStorageTimestamp), this.historyExpirationDays),
            messages: mappedMessages,
        });
    }
    static saveToLocalStorage(history) {
        if (this.shouldUseLocalStorage) {
            localStorage.setItem(this.liveChatHistoryStorageKey, JSON.stringify(history));
        }
    }
    static retrieveFromLocalStorage() {
        if (!this.shouldUseLocalStorage) {
            return;
        }
        const history = localStorage.getItem(this.liveChatHistoryStorageKey);
        if (history) {
            return JSON.parse(history);
        }
        return;
    }
    static deleteExpired(history) {
        Object.keys(history).forEach(timestamp => {
            if (Date.now() > history[Number(timestamp)].expiry) {
                delete history[Number(timestamp)];
            }
        });
    }
}
LiveChatHistoryService.liveChatHistoryStorageKey = 'chatHistory';
LiveChatHistoryService.historyExpirationDays = 7;
LiveChatHistoryService.shouldUseLocalStorage = isLocalStorageAvailable();
//# sourceMappingURL=liveChatHistoryService.js.map